// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import { informationStyles } from "@keller/Overrides/Widgets/InvoiceDetails/InvoiceDetailsInformation";
import { mergeWithCss, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

informationStyles.invoiceInformationGridContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 30px;
    `,
};

informationStyles.informationGridItem = {
    css: css`
        display: flex;
        gap: 16px 36px;
        flex-wrap: wrap;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            flex-wrap: nowrap;
        }
        @media print {
            gap: 12px 28px;
        }
    `,
};

informationStyles.shippingAddressGridItem = {
    css: css`
        width: 100%;
        gap: 30px;
        display: flex;
        justify-content: space-between;
        ${xScreen("lte", "xs")} {
            flex-wrap: wrap;
        }
        @media print {
            max-width: 500px;
            flex-direction: column;
        }
    `,
};

informationStyles.headingAndTextStyles = {
    ...mergeWithCss(xOrderInformationStyles.headingAndTextStyles, {
        wrapper: {
            css: css`
                width: fit-content;
            `,
        },
    }),
};
